import { render } from "./SimpleStackedBarchart.vue?vue&type=template&id=7630679e&scoped=true"
import script from "./SimpleStackedBarchart.vue?vue&type=script&lang=js"
export * from "./SimpleStackedBarchart.vue?vue&type=script&lang=js"

import "./SimpleStackedBarchart.vue?vue&type=style&index=0&id=7630679e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7630679e"]])

export default __exports__